module.exports = __webpack_public_path__ + "img/picture_product2.4da8e41a.png";